module.exports = __webpack_public_path__ + "img/app-yly.be66268e.webp";